import { render, staticRenderFns } from "./BidAskBrokers.vue?vue&type=template&id=a3421618&scoped=true"
import script from "./BidAskBrokers.vue?vue&type=script&lang=js"
export * from "./BidAskBrokers.vue?vue&type=script&lang=js"
import style0 from "./BidAskBrokers.vue?vue&type=style&index=0&id=a3421618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3421618",
  null
  
)

export default component.exports